module.exports = __webpack_public_path__ + "img/logo_short.ceea85fe.svg";